<!-- <div *ngIf="(firstname != 'New' && lastname != 'Voter') &&
            (firstname != null); else emailBlock" class="headband">
  <p class="inviteName">{{'HEADBAND.INVITATION' | translate}} {{firstname}} {{lastname}}</p>
</div>
<ng-template #emailBlock>
  <div class="headband">
    <p class="inviteName" *ngIf="!isClose">{{'HEADBAND.INVITATION' | translate}} {{email}}</p>
  </div>
</ng-template> -->
<headband [firstname]="firstname" [lastname]="lastname" [email]="email" [isClose]="isClose" [isMobile]="isMobile"
  [isTestActive]="isTestActive" (testVersionActivated)="activateTestModePopup($event)" [isValidated]="isValidated" [canHaveTestMode]="canHaveTestMode">
</headband>
<!-- Utilisation du composant Template APP-VIDEO-DEFAULT -->
<div *ngIf="!isMobile">
  <app-video-default [isLive]="isLive" [display]="votingType != 'list'">

    <!-- Dans lequel on inclu le composant que l'on souhaite (qui sera afficher au centre) -->
    <!-- Dans notre exemple le composant  app-included-component -->
    <app-detail-choice *ngIf="votingType != 'list'"></app-detail-choice>
    <app-list-poll *ngIf="votingType == 'list'" [firstname]="firstname" [lastname]="lastname" [email]="email"
      [poll]="electionDataJson" [endDate]="formattedEndDate" [startDate]="formattedStartDate" [privateKey]="privateKey" [validation]="validation"
      [votedStatuses]="votedStatuses" [isValidated]="isValidated" (twoFaSubmissionEvent)="validateSMS($event)"
      (sendSMSEvent)="resendSMS()" [userPhoneNumber]="userPhoneNumber" [validationErrorObj]="validationErrorObj"
      (passwordSubmissionEvent)="validatePassword($event)" [userRetriesRemaining]="userRetriesRemaining"
      [isValidationCodeError]="isValidationCodeError" [noMoreSMS]="noMoreSMS" [isValidatedPass]="isValidatedPass"
      [isValidatedSms]="isValidatedSms" [isWrongPhoneError]="isWrongPhoneError" [smsSent]="smsSent"
      (sendPhoneEvent)="setupPhone($event)" (sendSmsFirstEvent)="sendFirstSms()" [isClosed]="isClose"
      [isTestModeActive]="isTestActive" [testPoll]="testElectionDataJson"></app-list-poll>
    <app-enable-test-popup *ngIf="enableTestPopup" title="{{'POLL-WARNING.CATCH' | translate}}"
      firstText="{{'POLL-WARNING.TITLE' | translate}}" [confirmButton]="true" [modifyButton]="true"
      (endDetailsPopup)="enableTest($event)" [isMobile]="isMobile"> </app-enable-test-popup>

    <app-disable-test-popup *ngIf="disableTestPopup" title="{{'POLL-WARNING.CATCH' | translate}}"
      firstText="{{'POLL-WARNING.TITLE' | translate}}" [confirmButton]="true" [modifyButton]="true"
      (endDetailsPopup)="disableTest($event)" [isMobile]="isMobile"> </app-disable-test-popup>

  </app-video-default>
</div>
<div *ngIf="isMobile">
  <app-detail-choice *ngIf="votingType != 'list'"></app-detail-choice>
  <app-list-poll *ngIf="votingType == 'list'" [firstname]="firstname" [lastname]="lastname" [email]="email"
    [poll]="electionDataJson" [endDate]="formattedEndDate" [startDate]="formattedStartDate" [isMobile]="isMobile" [privateKey]="privateKey"
    [validation]="validation" [votedStatuses]="votedStatuses" [isValidated]="isValidated" [validationErrorObj]="validationErrorObj"
    (twoFaSubmissionEvent)="validateSMS($event)" (sendSMSEvent)="resendSMS()" [userPhoneNumber]="userPhoneNumber"
    (passwordSubmissionEvent)="validatePassword($event)" [userRetriesRemaining]="userRetriesRemaining"
    [isValidationCodeError]="isValidationCodeError" [noMoreSMS]="noMoreSMS" [isValidatedPass]="isValidatedPass"
    [isValidatedSms]="isValidatedSms" [isWrongPhoneError]="isWrongPhoneError" [smsSent]="smsSent"
    (sendPhoneEvent)="setupPhone($event)" (sendSmsFirstEvent)="sendFirstSms()"
    [isTestModeActive]="isTestActive" [testPoll]="testElectionDataJson"></app-list-poll>

  <app-enable-test-popup *ngIf="enableTestPopup" title="{{'POLL-WARNING.CATCH' | translate}}"
    firstText="{{'POLL-WARNING.TITLE' | translate}}" [confirmButton]="true" [modifyButton]="true"
    (endDetailsPopup)="enableTest($event)" [isMobile]="isMobile"> </app-enable-test-popup>

  <app-disable-test-popup *ngIf="disableTestPopup" title="{{'POLL-WARNING.CATCH' | translate}}"
    firstText="{{'POLL-WARNING.TITLE' | translate}}" [confirmButton]="true" [modifyButton]="true"
    (endDetailsPopup)="disableTest($event)" [isMobile]="isMobile"> </app-disable-test-popup>
</div>
